import { Document } from "@react-pdf/renderer";
import PdfPageBrandedIntro from "../pdfBuilder/ui/pages/PdfPageBrandedIntro";
import PdfPageCreditAuthBorrowerInfo from "./pages/PdfPageCreditAuthBorrowerInfo";
import PdfPageDisclosureAndSignature from "../pdfBuilder/ui/pages/PdfPageDisclosureAndSignature";

// import PdfPageBrandedIntro from "../pdfBuilder/pages/PdfPageBrandedIntro";
// import PdfPageCreditAuthBorrowerInfo from "./pages/PdfPageCreditAuthBorrowerInfo";
// import PdfPageDisclosureAndSignature from "./pages/PdfPageDisclosureAndSignature";

// PDF Document Component
export const CreditAuthorizationPDF = ({ formData }) => (
  <Document>
    <PdfPageBrandedIntro
      pageNumber={"1 of 3"}
      title={"Credit Authorization"}
      applicationFor={`${formData?.firstName} ${formData?.lastName}`}
      applicationDate={formData?.submission_date}
    />

    <PdfPageCreditAuthBorrowerInfo formData={formData} />
    <PdfPageDisclosureAndSignature pageNumber={"3 of 3"} formData={formData} />
  </Document>
);

export default CreditAuthorizationPDF;
